import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { SalesPaymentData, SalesPayment } from '../../../interfaces/masters/salespayment';
import { SalesPaymentApi } from '../api/salespayment.api';
@Injectable() 
export class SalesPaymentService extends SalesPaymentData{
 
  constructor(private api: SalesPaymentApi) {
    super();
  } 
  
  getall(url: string): Observable<SalesPayment[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<SalesPayment>{
      return this.api.getby_id(url);
  }

  create(url: string, data:SalesPayment[]): Observable<SalesPayment[]> {
    return this.api.add(url,data);
  }

  delete(url: string): Observable<SalesPayment[]> {
    return this.api.delete(url);
  }

  update(url: string, data:SalesPayment): Observable<SalesPayment> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }
}
